/**
 * Narrows an AWS GeoPlaces selection down to the string RocketReach's `location`
 * filter matches on.
 *
 * The bare city name and the typeahead's full label ("San Francisco, CA, USA")
 * were confirmed live to return identical totals, so we send the city and keep
 * the label only as a fallback for selections that carry no city.
 *
 * @param {object} address - the selection passed to LocationTypeahead's onAddressSelect
 * @returns {string} the value to send as the `location` search parameter
 */
const formatLocationForSearch = address => {
  if (!address) {
    return ''
  }

  return address.city || address.label || ''
}

export default formatLocationForSearch
